import { Modal } from '@/components/common/Modal';
import { CheckIcon } from '@/components/common/icons';
import type { FC } from 'react';
import { useId } from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface ExportDialogProps {
  /** The mode's label ("Začerněno"). */
  modeName: string;
  /** The file name the backend gave the export. */
  filename: string;
  onDownload: () => void;
  onClose: () => void;
}

/**
 * The prototype's "Export připraven" dialog, shown once the export has been produced: the mode, the
 * file name, "Stáhnout PDF" and "Zpět do revize". Without the prototype's CSV sentence — there is
 * no CSV report.
 */
export const ExportDialog: FC<ExportDialogProps> = ({ modeName, filename, onDownload, onClose }) => {
  const { t } = useTranslation();
  const titleId = useId();
  return (
    <Modal onClose={onClose} maxWidth={430} labelledBy={titleId} className="px-7 pb-[22px] pt-7">
      <div className="mb-3.5 flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-ok-soft">
          <CheckIcon size={18} strokeWidth={3} stroke="#0c6b54" />
        </div>
        <div id={titleId} className="text-base font-bold text-primary">
          {t('review.export.title')}
        </div>
      </div>
      <div className="text-[13px] leading-[1.6] text-muted">
        <Trans
          i18nKey="review.export.text"
          values={{ mode: modeName }}
          components={{ strong: <strong className="text-ink" /> }}
        />
      </div>
      <div className="mb-[18px] mt-3 break-all border border-line bg-surface px-3 py-2.5 text-[12.5px] font-semibold">
        {filename}
      </div>
      <div className="flex gap-2.5">
        <button
          type="button"
          onClick={onDownload}
          className="flex-1 cursor-pointer rounded border-none bg-primary px-3.5 py-[11px] text-[13.5px] font-semibold text-white hover:bg-primary-deep"
        >
          {t('review.export.download')}
        </button>
        <button
          type="button"
          onClick={onClose}
          className="cursor-pointer rounded border border-control bg-white px-3.5 py-[11px] text-[13.5px] font-semibold text-muted hover:border-primary hover:text-primary"
        >
          {t('review.export.back')}
        </button>
      </div>
    </Modal>
  );
};
